.title {
  margin-bottom: 4px;
  color: var(--color-gray-black);
  text-align: left;
}

.item {
  display: flex;
  column-gap: 4px;

  & + & {
    margin-top: 4px;
  }
}

.itemText {
  min-width: 0;
  max-width: 100%;
  padding: 3px 6px;
  border-radius: var(--border-radius-minimal);
  background-color: var(--color-gray-90);
  color: var(--color-gray-black);
}

.counter {
  flex-shrink: 0;
}

.empty {
  color: var(--color-gray-40);
}
